var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",attrs:{"compact":""},scopedSlots:_vm._u([{key:"default",fn:function({open}){return [(open)?_c('div',[_c('VideoPlayer',{attrs:{"video-url":_vm.video.videoUrl,"poster-image":_vm.video.videoPreviewUrl}})],1):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }